import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-08fa169f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "padding-16 tag-list"
};
const _hoisted_2 = ["onClick", "title"];
import ModuleCard from "@/views/college/components/ModuleCard.vue";
import { useRouter } from "vue-router";
import { College } from "@/api/college";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Tag',
  emits: ['getTags'],
  setup(__props, {
    emit: __emit
  }) {
    const tags = ref([]);
    const emit = __emit;
    const getTags = async () => {
      const res = await College.HotTags();
      tags.value = res.data;
      emit('getTags', tags.value);
    };
    getTags();
    const router = useRouter();
    //跳转详情
    const toDetail = val => {
      router.push({
        name: 'biaoqian',
        params: {
          tagId: val.id
        },
        query: {
          name: val.name
        }
      });
    };
    return (_ctx, _cache) => {
      return tags.value.length ? (_openBlock(), _createBlock(ModuleCard, {
        key: 0,
        title: "标签"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item,
            class: "tag",
            onClick: $event => toDetail(item),
            title: item.name
          }, _toDisplayString(item.name), 9, _hoisted_2);
        }), 128))])]),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});